import { render, staticRenderFns } from "./systems-register.page.vue?vue&type=template&id=71227cc7"
import script from "./systems-register.page.vue?vue&type=script&lang=ts"
export * from "./systems-register.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports